import React, { useEffect, useState } from "react";
import "./filters.css";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Button, TextField } from "@mui/material";
import { FaSearch } from "react-icons/fa";
import useFilterStore from "../../Stores/filterStore";

function FiltersComponent() {
  const tags = [
    "Tag 1",
    "Tag 2",
    "Tag 3",
    "Tag 4",
    "Tag 5",
    "Tag 6",
    "Tag 7",
    "Tag 8",
    "Tag 9",
    "Tag 10",
  ];

  const [tagsArray, setTagsArray] = useState([]);
  const [marcaTags, setMarcaTags] = useState([]);
  const [tipoTags, setTipoTags] = useState([]);
  const [minVal, setMinVal] = useState(0);
  const [maxVal, setMaxVal] = useState(0);
  const filters = useFilterStore((state) => state.filters);
  const replaceFilters = useFilterStore((state) => state.replaceFilters);

  useEffect(() => {
    fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/tags")
      .then((data) => data.json())
      .then((res) => {
        setMarcaTags([...res.filter((el) => el.tagType === "marca")]);
        setTipoTags([...res.filter((el) => el.tagType === "tipo")]);
      });
  }, []);

  const handleCheckTag = (isChecked, tag) => {
    const tempTagsArray = tagsArray;
    if (isChecked) {
      tempTagsArray.push(tag);
      setTagsArray([...tempTagsArray]);
    } else {
      const filteredArray = tempTagsArray.filter((el) => el !== tag);
      setTagsArray([...filteredArray]);
    }
  };

  const addFilters = () => {
    let tmpFilters = filters;
    if (tagsArray.length > 0) {
      tmpFilters = {
        ...tmpFilters,
        tag: {
          $all: [...tagsArray],
        },
      };
    } else {
      delete tmpFilters.tag;
    }
    if(maxVal != 0){
      tmpFilters = {
        ...tmpFilters,
        price: {
          $gte: minVal,
          $lte: maxVal
        }
      }
    }
    replaceFilters({ ...tmpFilters });
  };



  return (
    <div className="filters-container">
      <div className="filters">
        <div className="filters-list">
          <h1 style={{ marginBottom: "30px" }}>
            Filtros
          </h1>
          <h3>
            Marca del producto
          </h3>
          <FormGroup>
            <div className="filter-checkbox-container">
              {marcaTags.map((el) => (
                <FormControlLabel
                  className="filter-checkbox-1"
                  key={el.id}
                  control={
                    <Checkbox
                      onChange={(e) => handleCheckTag(e.target.checked, el.id)}
                    />
                  }
                  label={el.tagName}
                />
              ))}
            </div>
          </FormGroup>
          <h3>
            <b>Tipo de producto</b>
          </h3>
          <FormGroup>
            <div className="filter-checkbox-container">
              {tipoTags.map((el) => (
                <FormControlLabel
                  className="filter-checkbox-1"
                  key={el.id}
                  control={
                    <Checkbox
                      onChange={(e) => handleCheckTag(e.target.checked, el.id)}
                    />
                  }
                  label={el.tagName}
                />
              ))}
            </div>
          </FormGroup>
          <h3 style={{ margin: "15px 0px" }}>Rango de precio</h3>
          <TextField
            style={{ marginBottom: "10px" }}
            variant="outlined"
            label="Minimo"
            type="number"
            value={minVal}
            onChange={(e) => setMinVal(e.target.value)}
          />
          <TextField
            variant="outlined"
            label="Maximo"
            type="number"
            value={maxVal}
            onChange={(e) => setMaxVal(e.target.value)}
          />

          <div style={{ display: "flex" }}>
            <Button
              variant="contained"
              style={{ marginTop: "15px", marginLeft: "auto" }}
              onClick={addFilters}
            >
              Buscar <FaSearch style={{ marginLeft: "10px" }} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FiltersComponent;
